// XNGAGE CONFIDENTIAL
// __________________________
//
// Copyright (C) 2024 Xngage - All Rights Reserved
//
// All code or information contained herein is, and remains the
// property of Xngage LLC and its customers.  The intellectual
// and technical concepts contained are proprietary to Xngage LLC
// and may be covered by U.S. and Foreign Patents, patents in
// process, and are protected by trade secret or copyright law.
// Dissemination of this information or reproduction of this material
// is strictly forbidden unless prior written permission is obtained
// from Xngage LLC.
//

import { getNotifyStyle } from "@ces/App/Components/Notify";
import { FormFieldStyle } from "@ces/MobiusOverrides/FormField";
import { fontConfig } from "@ces/XDL/PreStyle/typography";
import { xScreen } from "@ces/XDL/Utilities";
import breakpointMediaQueries from "@ces/XDL/Utilities/breakpointMediaQueries";
import { orderUploadStyles } from "@insite/content-library/Components/OrderUpload";
import { BaseTheme } from "@insite/mobius/globals/baseTheme";
import { css } from "styled-components";

orderUploadStyles.downloadTemplateButton = {
    variant: "secondary",
    css: css`
        margin-bottom: 15px;
        ${xScreen("lte", "xs")} {
            width: 100%;
        }
    `,
};

orderUploadStyles.fileUploader = {
    buttonProps: {
        variant: "secondary",
        css: css`
            ${xScreen("lte", "xs")} {
                margin-left: 0;
                display: flex;
                width: 100%;
            }
        `,
    },
};

orderUploadStyles.includeFirstRowCheckbox = {
    css: css`
        margin: 15px 0;
        display: flex;
    `,
    iconProps: {
        css: css`
            vertical-align: middle;
        `,
    },
};

orderUploadStyles.uploadFileButton = {
    css: css`
        float: right;
        margin-left: 15px;
        width: initial;
        ${xScreen("lte", "xs")} {
            margin: 0;
            margin-bottom: 10px;
            width: 100%;
        }
    `,
};

orderUploadStyles.mainWrapper = {
    css: css`
        width: 100%;
        div[class^="UploadWrapper"] {
            justify-content: space-between;
            ${FormFieldStyle} {
                max-width: 450px;
            }
        }
    `,
};

orderUploadStyles.spinner = {
    size: 12,
    css: css`
        margin-right: 8px;
    `,
};

orderUploadStyles.uploadFileButtonLabel = {
    size: 12,
    weight: fontConfig.weight.bold,
};

orderUploadStyles.uploadingButtonLabel = {
    size: 12,
    weight: fontConfig.weight.bold,
    css: css`
        vertical-align: super;
    `,
};

orderUploadStyles.cancelUploadButton = {
    variant: "secondary",
    css: css`
        min-height: 33px;
        float: right;
        ${({ theme }: { theme: BaseTheme }) =>
            breakpointMediaQueries(
                theme,
                [
                    css`
                        width: 100%;
                    `,
                ],
                "max",
            )}
    `,
};

orderUploadStyles.orderCancellationSuccessfulText = {
    ...getNotifyStyle("success"),
};
